import { render, staticRenderFns } from "./CreditNoteColumns.vue?vue&type=template&id=594031a1&scoped=true"
import script from "./CreditNoteColumns.vue?vue&type=script&lang=js"
export * from "./CreditNoteColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594031a1",
  null
  
)

export default component.exports